// extracted by mini-css-extract-plugin
export default {"wrapper":"BoardActions_wrapper__rxxRn","boardName":"BoardActions_boardName__jtBx6","actions":"BoardActions_actions__jF5z+","action":"BoardActions_action__4ShVr"};